var dateUtils = {}
dateUtils.DateFormat = function(date, fmt) {
    fmt = fmt ? fmt : "yyyy-MM-dd HH:mm:ss";
    var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}
dateUtils.toTimeString = function(time, fmt) {
    //format:dd.HH:mm:ss
    var dTime = (60 * 60 * 24);
    var hTime = (60 * 60);
    var mTime = 60;
    var o = {
        "d+": Math.floor(time / dTime),
        "H+": Math.floor(time % dTime / hTime),
        "h+": Math.floor(time % dTime / hTime),
        "m+": Math.floor(time % dTime % hTime / mTime),
        "s+": Math.floor(time % dTime % hTime % mTime)
    }
    fmt = fmt ? fmt : "dd.HH:mm:ss";
    var isTrim = true;
    for (var k in o) {
        var iscTrim = false;
        if (isTrim) {
            if (o[k] != 0) {
                isTrim = false;
                iscTrim = true;
            }
        }
        if (!isTrim && iscTrim) {
            var rx = new RegExp("(" + k + ")").exec(fmt);
            if (rx != null && rx.length > 0) {
                fmt = fmt.substr(rx.index, fmt.length - rx.index);
                // console.log(fmt);
            }
        }
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
    return fmt;
}
dateUtils.JsonToDate = function(jsonDate) {
    //format:yyyy-MM-dd HH:mm:ss.S
    try {
        return new Date(parseInt(jsonDate.replace("/Date(", "").replace(")/", ""), 10));
    } catch (ex) {
        return "";
    }
}
dateUtils.JsonDateFormat = function(jsonDate, format) {
    //format:yyyy-MM-dd HH:mm:ss.S
    return dateUtils.DateFormat(dateUtils.JsonToDate(jsonDate), format);
}
dateUtils.DateToString = function(date, format) {
    //format:yyyy-MM-dd HH:mm:ss.S
    try {
        return dateUtils.DateFormat(date, format);
    } catch (ex) {
        return "";
    }
}
export default dateUtils;


// WEBPACK FOOTER //
// ./src/utils/dateUtils.js